import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail, ArrowRight } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_luxhemp/artifacts/eosdqbph_310C9C52-31F3-41A9-B491-B40A0F9BDE7A_L0_001-1_6_2026%2C%2012_08_40%20AM%20%281%29.png';

export default function Footer() {
  return (
    <footer className="relative bg-black text-ha-ink mt-32 ha-grain-surface border-t border-ha-ink/10" data-testid="site-footer">
      {/* Colossal wordmark editorial banner */}
      <div className="ha-container pt-20 md:pt-28 pb-10 md:pb-14 border-b border-ha-ink/10">
        <div className="text-center">
          <img
            src={LOGO_URL}
            alt="High Achievers"
            className="h-24 md:h-32 w-auto mx-auto opacity-90"
            loading="lazy"
          />
          <h2 className="ha-display text-ha-ink mt-8" style={{ fontSize: 'clamp(3rem, 10vw, 9rem)', lineHeight: '0.9' }}>
            <span className="ha-display-italic" style={{ color: '#B984E8' }}>High</span> Achievers.
          </h2>
          <p className="mt-6 ha-eyebrow" style={{ color: 'rgba(245,241,232,0.5)' }}>Asheville, NC · Est. 2023</p>
        </div>
      </div>

      {/* Newsletter band */}
      <div className="border-b border-ha-ink/10">
        <div className="ha-container py-16 md:py-20 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="ha-eyebrow mb-4" style={{ color: 'rgba(245,241,232,0.5)' }}>Newsletter</p>
            <h3 className="ha-display text-ha-ink" style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}>
              Sign up for <span className="ha-display-italic" style={{ color: '#5C8F2A' }}>20% off</span><br />your first order.
            </h3>
          </div>
          <form
            data-testid="footer-newsletter-form"
            onSubmit={(e) => { e.preventDefault(); }}
            className="flex flex-col sm:flex-row gap-3"
          >
            <input
              type="email"
              required
              placeholder="Your email address"
              data-testid="footer-newsletter-email"
              className="flex-1 h-14 px-6 rounded-full bg-transparent border border-ha-bg/20 text-ha-ink placeholder:text-ha-ink/40 font-body text-sm focus:outline-none focus:border-ha-bg/60 transition-colors"
            />
            <button
              type="submit"
              data-testid="footer-newsletter-submit"
              className="ha-btn ha-btn-green group"
            >
              Subscribe
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </form>
        </div>
      </div>

      {/* Main grid */}
      <div className="ha-container py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-12">
          <div className="col-span-2 md:col-span-1 space-y-5">
            <p className="ha-eyebrow" style={{ color: 'rgba(245,241,232,0.5)' }}>The house</p>
            <p className="font-serif text-lg text-ha-ink/85 leading-snug max-w-xs">
              A hemp house in Asheville, NC. Lab-tested flower, concentrates &amp; edibles for the discerning.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" aria-label="Instagram" className="text-ha-ink/60 hover:text-ha-green transition-colors"><Instagram className="w-5 h-5" /></a>
              <a href="#" aria-label="Facebook" className="text-ha-ink/60 hover:text-ha-green transition-colors"><Facebook className="w-5 h-5" /></a>
              <a href="#" aria-label="Twitter" className="text-ha-ink/60 hover:text-ha-green transition-colors"><Twitter className="w-5 h-5" /></a>
            </div>
          </div>

          <div>
            <p className="ha-eyebrow mb-5" style={{ color: 'rgba(245,241,232,0.5)' }}>Shop</p>
            <ul className="space-y-3">
              <li><Link to="/products" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">All Products</Link></li>
              <li><Link to="/products?category=flower" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Flower</Link></li>
              <li><Link to="/products?category=pre-rolls" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Pre-Rolls</Link></li>
              <li><Link to="/products?category=concentrates" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Concentrates</Link></li>
              <li><Link to="/products?category=edibles" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Edibles</Link></li>
              <li><Link to="/products?category=vapes" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Vapes</Link></li>
            </ul>
          </div>

          <div>
            <p className="ha-eyebrow mb-5" style={{ color: 'rgba(245,241,232,0.5)' }}>Company</p>
            <ul className="space-y-3">
              <li><Link to="/about" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">About</Link></li>
              <li><Link to="/locations" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Locations</Link></li>
              <li><Link to="/retailers" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Retailers</Link></li>
              <li><Link to="/coas" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Lab Tests</Link></li>
              <li><Link to="/contact" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Contact</Link></li>
              <li><Link to="/vita-verde" className="font-serif text-base text-ha-ink/85 hover:text-ha-green transition-colors">Vita Verde</Link></li>
            </ul>
          </div>

          <div>
            <p className="ha-eyebrow mb-5" style={{ color: 'rgba(245,241,232,0.5)' }}>Visit</p>
            <ul className="space-y-4">
              <li className="flex gap-2 text-ha-ink/85 text-sm font-body">
                <MapPin className="w-4 h-4 mt-0.5 text-ha-green shrink-0" />
                <span>
                  570 Merrimon Ave<br/>Asheville, NC 28804<br/>
                  <a href="tel:+18287027395" className="inline-flex items-center gap-1.5 mt-1 hover:text-ha-green transition-colors" data-testid="footer-phone-merrimon">
                    <Phone className="w-3 h-3" /> 828-702-7395
                  </a>
                </span>
              </li>
              <li className="flex gap-2 text-ha-ink/85 text-sm font-body">
                <MapPin className="w-4 h-4 mt-0.5 text-ha-purple shrink-0" style={{ color: '#B984E8' }} />
                <span>
                  332 Weaverville Rd<br/>Asheville, NC 28804<br/>
                  <a href="tel:+18284902863" className="inline-flex items-center gap-1.5 mt-1 hover:text-ha-green transition-colors" data-testid="footer-phone-weaverville">
                    <Phone className="w-3 h-3" /> 828-490-2863
                  </a>
                </span>
              </li>
              <li className="flex gap-2 text-ha-ink/85 text-sm font-body">
                <Mail className="w-4 h-4 mt-0.5 text-ha-ink/50 shrink-0" />
                <a href="mailto:info@highachieverscanna.com" className="hover:text-ha-green transition-colors break-all">info@highachieverscanna.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal */}
        <div className="mt-16 pt-8 border-t border-ha-ink/10 space-y-6">
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <Link to="/privacy" className="font-body text-xs uppercase tracking-[0.24em] text-ha-ink/50 hover:text-ha-ink/85 transition-colors font-medium">Privacy Policy</Link>
            <Link to="/refund-policy" className="font-body text-xs uppercase tracking-[0.24em] text-ha-ink/50 hover:text-ha-ink/85 transition-colors font-medium">Refund Policy</Link>
            <Link to="/sales-policy" className="font-body text-xs uppercase tracking-[0.24em] text-ha-ink/50 hover:text-ha-ink/85 transition-colors font-medium">Sales Policy</Link>
            <Link to="/compliance" className="font-body text-xs uppercase tracking-[0.24em] text-ha-ink/50 hover:text-ha-ink/85 transition-colors font-medium">Compliance</Link>
            <Link to="/legal" className="font-body text-xs uppercase tracking-[0.24em] text-ha-ink/50 hover:text-ha-ink/85 transition-colors font-medium">Legal</Link>
          </div>
          <p className="font-body text-[11px] leading-relaxed text-ha-ink/40 max-w-4xl">
            All products on this website contain 0.3% THC Delta-9 or less. No statement on this site has been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure or prevent any disease. Not for use by or sale to persons under the age of 21. Consult a physician before use if pregnant, nursing, or on medication. Products may cause a positive drug test — use at your own discretion.
          </p>
          <p className="font-body text-[11px] text-ha-ink/40 uppercase tracking-[0.24em] font-medium">
            © {new Date().getFullYear()} High Achievers Cannabis. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
